import * as tslib_1 from "tslib";
import { EventEmitter, ElementRef } from '@angular/core';
import { ItmAbstractElementRef } from '../itm-abstract-element-ref';
var ItmButtonComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ItmButtonComponent, _super);
    function ItmButtonComponent(el) {
        var _this = _super.call(this, el) || this;
        _this.buttonType = "button";
        _this.myClick = new EventEmitter();
        return _this;
    }
    ItmButtonComponent.prototype.onClick = function (evt) {
        this.myClick.emit();
    };
    return ItmButtonComponent;
}(ItmAbstractElementRef));
export { ItmButtonComponent };
